import { render, staticRenderFns } from "./GroupItemNew.vue?vue&type=template&id=27011338&scoped=true&"
import script from "./GroupItemNew.vue?vue&type=script&lang=js&"
export * from "./GroupItemNew.vue?vue&type=script&lang=js&"
import style0 from "./GroupItemNew.vue?vue&type=style&index=0&id=27011338&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27011338",
  null
  
)

export default component.exports